import styled from "@xstyled/styled-components";

export const Separator = styled.hr`
  color: gray-100;
  border: 0.5px solid;
  margin: 19 0;
`;
